module.exports = __webpack_public_path__ + "static/media/daringfood_expowest_3.ecee1186.png";